module.exports = __webpack_public_path__ + "img/values-img-3.15b60c5f.svg";